require('../../modules/es6.string.iterator');
require('../../modules/es6.array.from');
module.exports = require('../../modules/_core').Array.from;



//////////////////
// WEBPACK FOOTER
// ./~/react-app-polyfill/~/core-js/fn/array/from.js
// module id = 1680
// module chunks = 0